import { Button, Heading, Modal } from "@wexinc/wex-ui";
import { useState } from "react";
import { LoginMethods } from "services/security";
import useSecurityNavigation from "../useSecurityNavigation";

interface Props {
  email: string;
  invitationIdIfInvitationFlow?: number;
  invitationTokenIfInvitationFlow?: string;
  loginMethods: LoginMethods;
  redirectUri?: string;
  originalUri?: string;
  handleIDPButtonClick?: () => void;
}

const IdpPicker = (props: Props) => {
  const buttons: React.ReactElement[] = [];
  const {
    email,
    loginMethods,
    invitationIdIfInvitationFlow,
    invitationTokenIfInvitationFlow,
    redirectUri,
    originalUri,
    handleIDPButtonClick,
  } = props;
  const loginNavigation = useSecurityNavigation();
  const [actionIsInvoked, setActionIsInvoked] = useState(false);

  if (loginMethods.usernameAndPasswordEnabled) {
    buttons.push(
      <IdpPickerButton
        key="usernameAndPassword"
        name="usernameAndPassword"
        label="Username and Password"
        action={() => {
          setActionIsInvoked(true);
          invitationIdIfInvitationFlow
            ? loginNavigation.navigateToLoginRegistration(
                email,
                invitationIdIfInvitationFlow!,
                invitationTokenIfInvitationFlow,
              )
            : loginNavigation.navigateToUsernamePasswordLogin(email, redirectUri, originalUri);
          handleIDPButtonClick?.();
        }}
        disabled={actionIsInvoked}
      />,
    );
  }

  loginMethods.identityProviders.forEach((i) => {
    buttons.push(
      <IdpPickerButton
        key={i.id}
        name={i.id}
        label={i.name}
        action={() => {
          setActionIsInvoked(true);
          loginNavigation.navigateToIdpLogin(
            email,
            i.id,
            redirectUri,
            invitationIdIfInvitationFlow
              ? loginNavigation.getInvitationRegistrationPath(
                  email,
                  invitationIdIfInvitationFlow,
                  invitationTokenIfInvitationFlow,
                )
              : originalUri,
          );
          handleIDPButtonClick?.();
        }}
        disabled={actionIsInvoked}
      />,
    );
  });

  return (
    <Modal>
      <Heading
        size="medium"
        className="text-center"
      >
        Select Login Method
      </Heading>
      <ul className="pt-2">
        {buttons.map((i) => (
          <li
            key={i.key}
            className="px-4 py-3"
          >
            {i}
          </li>
        ))}
      </ul>
    </Modal>
  );
};

interface IdpPickerButtonProps {
  name: string;
  label: string;
  action: () => void;
  disabled: boolean;
}

const IdpPickerButton = (props: IdpPickerButtonProps) => {
  return (
    <Button
      testId={props.name}
      onClick={props.action}
      className="!py-4 w-full"
      disabled={props.disabled}
    >
      {props.label}
    </Button>
  );
};

export default IdpPicker;
